import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class RedemptionsService {

  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getRedemptions(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/redemptions?' + size + urlParams;
    return this.http.get(url);
  }

  public getRedemptionsTotal(params: any) {
    let urlParams = '';
    const size = 'len=6';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    return this.http.get('web/redemptions/stats' + '?' + size + urlParams);
  }

  public getRedemptionsDetails(id: any) {
    return this.http.get(`web/redemptions/${id}/details`)
  }

  public redeem(code: string, amount: number) {
    return this.http.post('web/dashboard/redeem?code=' + code + '&amount=' + amount, {})
  }
}
